export function getComputedStyle(el: HTMLElement): CSSStyleDeclaration {
  return window.getComputedStyle(el);
}
